import React from 'react';
import {
  CadAddressValueType,
  CadAreaValueType,
  CadLocationValueType,
  CadPremiseValueType
} from '../../../../../../Models/CadReportValue';
import { FieldItemList } from '../../../CommonBody/FieldItemList/FieldItemList';

const getAreaNameValue = (
  type: string, //district or grid
  name: string,
  areas: CadAreaValueType[]
): string => {
  const area = areas.find((area) => area.name === name && area.type === type);
  return area ? area.name : name;
};

interface LocationInformation
  extends
    Omit<CadAddressValueType, 'id' | 'coords'>,
    Omit<CadPremiseValueType, 'id' | 'address_ids'> {}

const getLocationFields = (
  location: CadLocationValueType,
  premises: CadPremiseValueType[],
  Addresses: CadAddressValueType[]
) => {
  const locationInfo: LocationInformation = {
    ...(premises.find(
      (premise) => premise.id === location.premise_id
    ) as CadPremiseValueType),
    ...(Addresses.find(
      (address) => address.id === location.address_id
    ) as CadAddressValueType)
  };

  let fields = [
    {
      label: 'Address',
      value: locationInfo['full'] as string,
      type: 'string'
    },
    {
      label: 'District',
      value: getAreaNameValue(
        'district',
        locationInfo['district'] as string,
        locationInfo.areas as CadAreaValueType[]
      ),
      type: 'string'
    },
    {
      label: 'Grid',
      value: getAreaNameValue(
        'grid',
        locationInfo['grid'] as string,
        locationInfo.areas as CadAreaValueType[]
      ),
      type: 'string'
    },
    {
      label: 'Cross Street',
      value: locationInfo['cross_street'] as string,
      type: 'string'
    },
    {
      label: 'Premise',
      value: locationInfo['name'] as string,
      type: 'string'
    },
    {
      label: 'Premise Type',
      value: locationInfo['type'] as string,
      type: 'string'
    }
  ];

  return fields;
};

export interface CadLocationInformationProps {
  location: CadLocationValueType;
  premises: CadPremiseValueType[];
  Addresses: CadAddressValueType[];
}

export const CadLocationInformation = ({
  location,
  premises,
  Addresses
}: CadLocationInformationProps): React.ReactElement<CadLocationInformationProps> => {
  return (
    <FieldItemList
      title="Location"
      fields={getLocationFields(location, premises, Addresses)}
    />
  );
};
